const modelroomSlide = (() => {
  const pageModelroom = (document.getElementById("pageModelroom") != null);
  if (pageModelroom) {



    let jsSecMain = document.getElementById("jsSecMain")
    let jsSwiper = jsSecMain.querySelector(".jsSwiper")
    let jsSwiper2 = jsSecMain.querySelector(".jsSwiper2")
    let btnPrev = jsSecMain.querySelector(".js-swiper-btn-prev")
    let btnNext = jsSecMain.querySelector(".js-swiper-btn-next")

    const swiper = new Swiper(jsSwiper, {
      slidesPerView: 7
    });

    const swiper2 = new Swiper(jsSwiper2, {
      thumbs: {
        swiper: swiper
      },
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,

      },
      loop: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      speed: 1000,
      navigation: {
        nextEl: btnNext,
        prevEl: btnPrev
      }
    });



  }
})();
export default modelroomSlide;